import { pluck } from 'ramda';
import { combineReducers } from 'redux';
import ducks from './ducks/ducks';
import { createReducer } from './fsm/machine';

const reducers = pluck('reducer')(ducks);
const createRootReducer = machine =>
  machine ? combineReducers({ ...reducers, xstate: createReducer(machine.initialState) }) : combineReducers(reducers);
export default createRootReducer;
